import { render, staticRenderFns } from "./rimodal.vue?vue&type=template&id=fdbb85bc"
import script from "./rimodal.vue?vue&type=script&lang=js"
export * from "./rimodal.vue?vue&type=script&lang=js"
import style0 from "./rimodal.vue?vue&type=style&index=0&id=fdbb85bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports